import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareddataService {

  private orderDateTime = new BehaviorSubject([]);
  sharedOrderDateTime = this.orderDateTime.asObservable();

  private resSubMenuCartData = new BehaviorSubject([]);
  sharedSubMenuCartData = this.resSubMenuCartData.asObservable();

  private resDataapi = new BehaviorSubject([]);
  sharedMessage = this.resDataapi.asObservable();

  constructor() { }

  nextMessage(resDataapi: any) {
    this.resDataapi.next(resDataapi)
  }
  
  nextSubMenuCart(resSubMenuCartData: any) {
    this.resSubMenuCartData.next(resSubMenuCartData)
  }
  
  nextOrderDateCart(orderDateTime: any) {
    this.orderDateTime.next(orderDateTime)
  }
}
